import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';
import { Link, Tooltip } from '@mui/material';
import { Text } from './Text';

export const RowList = ({ content }) => {
	const theme = useTheme();
	return (
		<Container>
			{content.map(({ variation, label, href, text, details, width }, index) => {
				const content = (
					<BoxItem
						color={theme.kpi[variation]}
						width={width || `${10 + 7 * String(text).length}px`}
					>
						<FloatText>{label}</FloatText>
						{href ? (
							<BodyText>
								<RowLink color="normal" {...{ href }}>{text}</RowLink>
							</BodyText>
						) : (
							<BodyText>{text ?? '-'}</BodyText>
						)}
					</BoxItem>
				);
				if (!details) {
					return content;
				}
				const tooltipContent = (
					<>{details.map((detail) => <P key={detail}>{detail}</P>)}</>
				);
				return (
					<Tooltip title={tooltipContent}>
						{content}
					</Tooltip>
				);
			})}
		</Container>
	);
};

const Container = styled.div`
	position: relative;
	width: auto;
	height: 25px;

	&:hover p {
		visibility: visible !important;
	}
`;

const BoxItem = styled.div`
	position: relative;
	display: inline-block;
	text-align: center;
	background-color: ${({ color }) => color};
	padding-top: 0px;
	padding-left: 5px;
	padding-right: 5px;
	box-sizing: border-box;
	width: ${({ width }) => width};
	min-width: 60px;
`;

const BodyText = styled(Text)`
	font-size: 0.8rem !important;
	text-align: center;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-height: 32px;
`;

const RowLink = styled(Link)`
`;

const FloatText = styled(Text)`
  top: ${({ isBottom }) => isBottom ? 18 : -15}px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  font-size: 0.6rem !important;
  display: block;
	width: auto;
	padding: 0 5px;
	background-color: rgba(255,255,255,.8);
	backdrop-filter: blur(5px);
	border: 1px solid rgba(0,0,0,.3);
	visibility: hidden;
	box-shadow: 0 0 2px 0 #ccc;
`;

const P = styled(Text)`
  font-size: 0.6rem !important;
`;
